import { gql } from '@apollo/client'

const getSignatureKey = gql`
  query GetSignatureKey {
    getSignatureKey {
      key
      ret
    }
  }
`
export default getSignatureKey
